import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0;\n  position: relative;\n\n  /* Checkmark */\n  &::before {\n    position: absolute;\n    display: block;\n    width: 24px;\n    height: 24px;\n\n    transform: scale(0);\n    transform-origin: 50%;\n\n    transition: transform 0.1s var(", ");\n\n    content: '';\n    mask: ", ";\n  }\n\n  /* Checkmark checked */\n  &:checked::before {\n    background-color: var(\n      ", "\n    );\n\n    transform: scale(1);\n  }\n\n  /* Checkmark invalid */\n  &:invalid::before {\n    background-color: ", ";\n  }\n\n  /* Checkmark disabled */\n  &:disabled::before {\n    background-color: var(\n      ", "\n    );\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { StyledInput } from '../GenericOption/GenericOption.styles';
var checkmarkIcon = "url(data:image/svg+xml;utf8,".concat(encodeURIComponent("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M6 12.2l4.3 4.2 8.1-10.3\" stroke=\"#000000\" fill=\"none\" />\n  </svg>"), ")");
export var StyledCheckbox = styled(StyledInput).attrs({
  type: 'checkbox'
})(_templateObject(), function (props) {
  return props.theme.easing;
}, checkmarkIcon, function (props) {
  return props.theme.colors.interaction.secondary.filled;
}, function (props) {
  return props.invalid && "var(".concat(props.theme.colors.ui.error, ")");
}, function (props) {
  return props.theme.colors.interaction.tertiary.disabled;
});